import { Component, inject, OnInit, HostListener  } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../auth/service/auth.service';
import { ProgressBarService } from '../../../services/progress/progress-bar.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {
  apiUrl = environment.apiUrl;
  testUrl = 'https://test.api.tridimo.de/api/'
  ProductionUrl = 'https://api.tridimo.de/api/'
  router = inject(Router);
  userName: any;
  isDropdownOpen: boolean = false; 
  role: string | null = null;
  roleRoute: any
  tokenExpiredValue: any

  constructor(private authService: AuthService, private progressBarService: ProgressBarService) {}

  /**
 * Initialisiert die Header-Komponente.
 * - Lädt Benutzerinformationen (Name, Rolle) aus dem Storage
 * - Setzt Standardwerte, falls keine Daten vorhanden sind
 */
  ngOnInit(): void {
    this.role = localStorage.getItem('role');
    const firstname = localStorage.getItem('firstName')
    const lastName = localStorage.getItem('lastName')
    this.roleRoute = sessionStorage.getItem('roleRoute')

    if(firstname && lastName) {
      this.userName = firstname + ' ' + lastName
    } else {
      this.userName = 'unknown User Name'
    }
  }

  /**
 * Öffnet das externe Intranet je nach Umgebung (Test oder Production).
 * Dabei werden lokale und Session-Daten vorher gelöscht.
 */
  openIntranet() {
    localStorage.clear()
    sessionStorage.clear()
    if(this.apiUrl === this.ProductionUrl) {
      window.location.href = 'https://intranet.tridimo.de/';
     } else if(this.apiUrl === this.testUrl) {
      window.location.href = 'https://test.intranet.tridimo.de/';
     }
  }

  /**
 * Öffnet oder schließt das Dropdown-Menü im Header.
 * Verhindert das Schließen beim Klick innerhalb des Elements.
 */
  toggleDropdown(event: MouseEvent): void {
    event.stopPropagation();
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  /**
 * Schließt das Dropdown-Menü, wenn außerhalb geklickt wird.
 */
  @HostListener('document:click', ['$event'])
  closeDropdown(event: MouseEvent): void {
    const clickedInside = (event.target as HTMLElement).closest('.dropdown');
    if (!clickedInside) {
      this.isDropdownOpen = false;
    }
  }

  /**
 * Navigiert in den Admin-Bereich, wenn der Benutzer berechtigt ist.
 * Setzt zusätzlich die Routing-Information im SessionStorage.
 */
  adminLogin() {
    if (this.authService.isLoggedIn() && localStorage.getItem('role') === 'Admin' || 'Buero') {
      this.router.navigate(['/admin']);
      this.roleRoute = sessionStorage.setItem('roleRoute', 'admin-route')
    }
  }

  /**
 * Verlässt den Admin-Bereich und navigiert zurück zur Hauptansicht.
 * Setzt die Routing-Information im SessionStorage zurück.
 */
  adminLogout() {
    if (this.authService.isLoggedIn() && localStorage.getItem('role') === 'Admin' || 'Buero') {
      this.roleRoute = sessionStorage.setItem('roleRoute', 'main-route')
      this.router.navigate(['/Einsatzbestaetigung']);
    }
  }

  /**
 * Meldet den Benutzer aus der Anwendung ab.
 */
  logout() {
    this.authService.logout()
  }

  /**
 * Lädt die Startseite neu und aktiviert die Progressbar.
 */
  reloadPage() {
    this.progressBarService.show(0);
    this.router.navigate(['Startseite']);
  }
}
